import React, { useState, useEffect } from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const SliderDisclaimer = () => {
  const [imageDepartments, setImageDepartments] = useState([]);
  const [textDepartments, setTextDepartments] = useState([]);
  const [newImage, setNewImage] = useState(null);
  const [newText, setNewText] = useState('');
  const [addSuccessMessage, setAddSuccessMessage] = useState('');
  const [addError, setAddError] = useState('');
  const [updateSuccessMessage, setUpdateSuccessMessage] = useState('');
  const [updateError, setUpdateError] = useState('');
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [editingImageDepartment, setEditingImageDepartment] = useState(null);
  const [editingTextDepartment, setEditingTextDepartment] = useState(null);
  const [imageErrorUpdate, setImageErrorUpdate] = useState('');

  useEffect(() => {
    fetchDepartmentsImages();
    fetchDepartmentsTexts();
  }, []);

  const fetchDepartmentsImages = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/SliderDisclaimer/listImages');
      setImageDepartments(response.data.data);
    } catch (error) {
      console.error('Error fetching department images:', error);
    }
  };

  const fetchDepartmentsTexts = async () => {
    try {
      const response = await axios.get('https://back.zubilaw.com/disclaimer/list');
      setTextDepartments(response.data.data);
    } catch (error) {
      console.error('Error fetching department texts:', error);
    }
  };

  const addDepartmentImage = async () => {
    const formData = new FormData();
    formData.append('slider', newImage);

    try {
      await axios.post('https://back.zubilaw.com/SliderDisclaimer/addImage', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setAddSuccessMessage('Department image added successfully!');
      setTimeout(() => {
        setAddSuccessMessage('');
      }, 5000);
      setNewImage(null);
      fetchDepartmentsImages();
    } catch (error) {
      setAddError('Please select an image to upload.');
      console.error('Error adding department image:', error);
    }
  };

  const addDepartmentText = async () => {
    const data = {
      text: newText,
    };

    try {
      await axios.post('https://back.zubilaw.com/SliderDisclaimer/addText', data, {
        headers: { 'Content-Type': 'application/json' },
      });
      setAddSuccessMessage('Department text added successfully!');
      setTimeout(() => {
        setAddSuccessMessage('');
      }, 5000);
      setNewText('');
      fetchDepartmentsTexts();
    } catch (error) {
      setAddError('Please enter text to add.');
      console.error('Error adding department text:', error);
    }
  };

  const updateDepartmentImage = async (id) => {
    const formData = new FormData();
    formData.append('slider', newImage);

    try {
      await axios.put(`https://back.zubilaw.com/SliderDisclaimer/updateImage/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setUpdateSuccessMessage('Department image updated successfully!');
      setEditingImageDepartment(null);
      setNewImage(null);
      fetchDepartmentsImages();
    } catch (error) {
      setUpdateError('Error updating department image.');
      console.error('Error updating department image:', error);
    }
  };

  const updateDepartmentText = async (id) => {
    const data = {
      text: newText,
    };

    try {
      await axios.put(`https://back.zubilaw.com/disclaimer/update/${id}`, data, {
        headers: { 'Content-Type': 'application/json' },
      });
      setUpdateSuccessMessage('Department text updated successfully!');
      setEditingTextDepartment(null);
      setNewText('');
      fetchDepartmentsTexts();
    } catch (error) {
      setUpdateError('Error updating department text.');
      console.error('Error updating department text:', error);
    }
  };

  const deleteDepartment = (id) => {
    setDepartmentToDelete(id);
    setShowDeletePopup(true);
  };

  const performDelete = async () => {
    try {
      await axios.delete(`https://back.zubilaw.com/SliderDisclaimer/delete/${departmentToDelete}`);
      setShowDeletePopup(false);
      fetchDepartmentsImages();
      fetchDepartmentsTexts();
    } catch (error) {
      console.error('Error deleting department:', error);
    }
  };

  const closeUpdateForm = () => {
    setEditingImageDepartment(null);
    setEditingTextDepartment(null);
    setNewImage(null);
    setNewText('');
  };

  const modules = {
    toolbar: [
      [{ 'color': [] }, { 'background': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'header': '1' }, { 'header': '2' }, { 'header': [3, 4, 5, 6] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image', 'video'],
      ['clean']                                         
    ],
  };
  
  const formats = [
    'background', 'color', 'bold', 'italic', 'underline', 'strike', 'header',
    'list', 'bullet', 'align', 'link', 'image', 'video'
  ];

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Manage Department Images</CardTitle>
            </CardHeader>
            <CardBody>
              <Form>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <label>Image</label>
                      <Input
                        type="file"
                        onChange={(e) => setNewImage(e.target.files[0])}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <Button
                      className="btn-round"
                      color="primary"
                      onClick={addDepartmentImage}
                    >
                      Add Department Image
                    </Button>
                    {addSuccessMessage && (
                      <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                        {addSuccessMessage}
                      </div>
                    )}
                    {addError && (
                      <div style={{ color: "red", marginTop: "5px" }} role="alert">
                        {addError}
                      </div>
                    )}
                  </Col>
                </Row>
              </Form>
              <Table responsive>
  <thead className="text-primary">
    <tr>
      <th>Image</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    {imageDepartments.map((department, index) => (
      <tr key={department.id}>
        <td>
          <img
            src={`https://back.zubilaw.com/${department.slider}`}
            alt="Department Slider"
            style={{ maxWidth: '300px', maxHeight: '200px' }}
          />
        </td>
        <td>
          <Button
            color="success"
            onClick={() => {
              setEditingImageDepartment(department);
              setNewImage(null);
            }}
          >
            Update Image
          </Button>{" "}
          {index !== 0 && (
            <Button
              color="danger"
              onClick={() => deleteDepartment(department.id)}
            >
              Delete
            </Button>
          )}
        </td>
      </tr>
    ))}
  </tbody>
</Table>

            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <CardTitle tag="h4">Text Details</CardTitle>
            </CardHeader>
            <CardBody>
              
              <Table responsive>
                <thead className="text-primary">
                  <tr>
                    <th>Text</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
  {textDepartments.map((department) => (
    department.text ? (
      <tr key={department.id}>
        <td dangerouslySetInnerHTML={{ __html: department.text }}></td>
        <td>
          <Button
            color="success"
            onClick={() => {
              setEditingTextDepartment(department);
              setNewText(department.text);
            }}
          >
            Update Text
          </Button>{" "}
        </td>
      </tr>
    ) : null
  ))}
</tbody>

              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {(editingImageDepartment || editingTextDepartment) && (
        <CardFooter>
          <Form>
            <Row>
              {editingTextDepartment && (
                <Col md="6">
                  <FormGroup>
                    <label>Text</label>
                    <div
                      style={{
                        height: '300px',
                        overflowY: 'auto',
                      }}
                    >
                      <ReactQuill
                        value={newText}
                        onChange={setNewText}
                        
                        modules={modules} 
  formats={formats}
  style={{ height: '80%', color: 'black' }}
/>
                    </div>
                  </FormGroup>
                </Col>
              )}

              {editingImageDepartment && (
                <Col md="6">
                  <FormGroup>
                    <label>Image</label>
                    <Input
                      type="file"
                      onChange={(e) => setNewImage(e.target.files[0])}
                    />
                  </FormGroup>
                </Col>
              )}
              <Col md="12">
                {editingTextDepartment && (
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => updateDepartmentText(editingTextDepartment.id)}
                  >
                    Update Text
                  </Button>
                )}{" "}
                {editingImageDepartment && (
                  <Button
                    className="btn-round"
                    color="primary"
                    onClick={() => updateDepartmentImage(editingImageDepartment.id)}
                  >
                    Update Image
                  </Button>
                )}{" "}
                <Button
                  className="btn-round"
                  color="secondary"
                  onClick={closeUpdateForm}
                >
                  Cancel
                </Button>
                {updateSuccessMessage && (
                  <div className="alert alert-success" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                    {updateSuccessMessage}
                  </div>
                )}
                {updateError && (
                  <div className="alert alert-danger" role="alert" style={{ width: '50%', margin: '10px auto', textAlign: 'center' }}>
                    {updateError}
                  </div>
                )}
                {imageErrorUpdate && (
                  <div style={{ color: 'red' }}>
                    {imageErrorUpdate}
                  </div>
                )}
              </Col>
            </Row>
          </Form>
        </CardFooter>
      )}

      <Modal isOpen={showDeletePopup} toggle={() => setShowDeletePopup(false)}>
        <ModalHeader toggle={() => setShowDeletePopup(false)}>Delete Department</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this department?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={performDelete}>Delete</Button>
          <Button color="secondary" onClick={() => setShowDeletePopup(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SliderDisclaimer;
